import React, { useState, useEffect } from 'react';
import { Popover, CardBody, CardFooter, Button, RadioGroup, Radio } from '@panwds/react-ui';
import { PillValue } from '../Pill/PillValue.esm.js';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';

function RangeFilterOptions({ items, label, required = false, disabled = false, radioSelected, updateRadioSelected, onClearClick, name, rangeValues, isFullWidth, }) {
    const { setFilters } = useFilters();
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        // set initial filters on load
        if (loaded === false) {
            setFilters({
                [name]: rangeValues,
            });
        }
        setLoaded(true);
    }, [rangeValues]);
    const onRadioChange = (e) => {
        updateRadioSelected(e.target.value);
    };
    const onApplyClick = () => {
        setFilters({
            [name]: rangeValues,
        });
    };
    const button = (React.createElement(PillValue, { labelKey: label, labelValue: label, addClassName: "tw-rounded", required: required, disabled: disabled, isFullWidth: isFullWidth }));
    const getRadioGroupItems = () => {
        return items === null || items === void 0 ? void 0 : items.map((item) => {
            let radio = (React.createElement(Radio, { value: item.value, checked: false }, item.children));
            let generatedOption = null;
            if (radioSelected === item.value) {
                radio = (React.createElement(Radio, { value: item.value, checked: true }, item.children));
                generatedOption = (React.createElement("div", { className: "tw-ml-8", key: item.value }, item.rangeOptions));
            }
            return (React.createElement("div", { key: item.value },
                " ",
                radio,
                " ",
                generatedOption));
        });
    };
    const radioOptions = () => {
        return (React.createElement("div", { className: "tw-space-y-4" },
            React.createElement(RadioGroup, { name: "rangeFilter", value: radioSelected, onChange: onRadioChange }, getRadioGroupItems())));
    };
    return (React.createElement("div", { className: "tw-rounded", "data-testid": name, "data-metrics": name },
        React.createElement(Popover, { label: label, showLabel: false, button: button },
            React.createElement(CardBody, { addClassName: " tw-flex tw-flex-col tw-space-y-2 tw-w-64" }, radioOptions()),
            React.createElement(CardFooter, { secondaryContent: React.createElement("a", { className: "tw-text-link dark:tw-text-dark-bg-link tw-cursor-pointer tw-text-xs tw-font-semibold", onClick: onClearClick }, "Clear") },
                React.createElement(Button, { appearance: "primary", onClick: onApplyClick }, "Apply")))));
}

export { RangeFilterOptions };
//# sourceMappingURL=RangeFilterOptions.esm.js.map
